var React = require('react');

function SummaryBorder (props) {
    return React.createElement("svg",props,[React.createElement("polyline",{"fill":"none","stroke":"#7A7A7A","strokeMiterlimit":"10","points":"263.7,0 230.1,21.5 131.9,21.5 ","key":0}),React.createElement("line",{"fill":"none","stroke":"#D8D8D8","strokeMiterlimit":"10","strokeDasharray":"4","x1":"131.9","y1":"21.5","x2":"31.5","y2":"21.5","key":1}),React.createElement("polygon",{"fill":"#D8D8D8","points":"31.5,21.5 27.1,25.9 0,25.9 0,21.5 ","key":2}),React.createElement("line",{"fill":"none","stroke":"#D8D8D8","strokeMiterlimit":"10","x1":"31.5","y1":"21.5","x2":"0","y2":"21.5","key":3})]);
}

SummaryBorder.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 263.7 25.9","enableBackground":"new 0 0 263.7 25.9","xmlSpace":"preserve"};

module.exports = SummaryBorder;

SummaryBorder.default = SummaryBorder;
